import {
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  Typography,
} from "@mui/material";
import {
  CustomCalendarTodayOutlinedIcon,
  CustomDatePicker,
  CustomInputLabel,
  CustomRequiredInputLabel,
  CustomTextFeildforFamily,
  StyledDateContainer,
  CommonButton,
  CommonOutlinedButton,
  CustomCheckbox,
} from "../../common/StyledComponents/StyledFields";
import styles from "../reportSection.module.scss";
import { useEffect, useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { apiRequest } from "../../../infrastructure/backendService";
import CustomSelectField from "../../common/CustomSelectField/CustomSelectField";
import { PersonSearch } from "@mui/icons-material";
import ReportsSearchDevotee from "../ReportsSearchDevotee/ReportsSearchDevotee";
import CONSTANTS from "../../../config/constants.json"
import { ClipLoader } from "react-spinners";
import CustomizedSwitch from "../../common/CustomToggle/CustomToggle";

const DevoteeReport = ({ sendDataToParent, getReportData }: any) => {
  const formFieldsDevoteeReport = {
    lastNameStartsWith: "",
    zipCode: "",
    city: "",
    email: "",
    signInName: "",
    homePhoneNumber: "",
    workPhoneNumber: "",
    dateOfBirth: "",
    joiningFromDate: "",
    joiningToDate: "",
    category: "",
    state: "",
    country: "",
    preferredLanguage: "",
    onlyRegisteredDevotees:false
  };
  const [formData, setformData] = useState(
    formFieldsDevoteeReport
  );

  const handleFieldChange = (field: any, value: any) => {
    if (
      field === "dateOfBirth" ||
      field === "joiningFromDate" ||
      field === "joiningToDate"
    ) {
      const formattedDate = dayjs(value, "MM/DD/YYYY");
      setformData({
        ...formData,
        [field]: formattedDate.isValid()
          ? formattedDate.format("MM/DD/YYYY")
          : "",
      });
    } else {
      setformData({
        ...formData,
        [field]: value,
      });
    }
  };

  const tableColumns = [
    { ID: "Serial Number", fieldName: "Serial Number" },
    { ID: "Name", fieldName: "Name" },
    { ID: "Sign-in Name", fieldName: "Sign-in Name" },
    { ID: "Address", fieldName: "Address" },
    { ID: "Home Phone", fieldName: "Home Phone" },
    { ID: "Work Phone", fieldName: "Work Phone" },
    { ID: "Email", fieldName: "Email" },
    { ID: "Preferred Language", fieldName: "Preferred Language" },
    { ID: "Date of Birth", fieldName: "Date of Birth" },
  ];

  const checkBoxSequence = [
    { ID: "Name", fieldName: "Name" },
    { ID: "Address", fieldName: "Address" },
    { ID: "Sign-in Name", fieldName: "Sign-in Name" },
    { ID: "Home Phone", fieldName: "Home Phone" },
    { ID: "Work Phone", fieldName: "Work Phone" },
    { ID: "Email", fieldName: "Email" },
    { ID: "Preferred Language", fieldName: "Preferred Language" },
    { ID: "Date of Birth", fieldName: "Date of Birth" },
    { ID: "Serial Number", fieldName: "Serial Number" },
  ];
  const initialCheckedItems = tableColumns.reduce((acc, item) => {
    if(item.ID === 'Name' || item.ID === 'Address'){
      acc[item.ID] = true;
    }else{
      acc[item.ID] = false;
    }
    return acc;
  }, {} as { [key: string]: boolean });

  const [checkedItems, setCheckedItems] = useState<{ [key: string]: boolean }>(
    initialCheckedItems
  );
  const [categories, setCategories] = useState<any[]>([]);
  const [states, setStates] = useState<any[]>([]);
  const [languageItems, setLanguageItems] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [loading_zipcode, setLoading_zipcode] = useState<boolean>(false);


  const handleCheckboxChange = (id: any) => {
    const newCheckedItems = { ...checkedItems, [id]: !checkedItems[id] };
    setCheckedItems(newCheckedItems);
  };
  const selectedColumns = Object.keys(checkedItems).filter(
    (key) => checkedItems[key]
  );
  const handlSubmitDevoteereport = () => {
    const reqBody = {
      ...(formData.lastNameStartsWith && { lastNameStartsWith: formData.lastNameStartsWith }),
      ...(formData.zipCode && { zipCode: formData.zipCode }),
      ...(formData.category && { categoryId: Number(formData.category) }),
      ...(formData.city && { city: formData.city }),
      ...(formData.state && { state: formData.state }),
      ...(formData.country && { country: formData.country }),
      ...(formData.email && { email: formData.email }),
      ...(formData.signInName && { signInName: formData.signInName }),
      ...(formData.homePhoneNumber && { homePhoneNumber: Number(formData.homePhoneNumber) }),
      ...(formData.workPhoneNumber && { workPhoneNumber: Number(formData.workPhoneNumber) }),
      ...(formData.preferredLanguage && { preferredLanguage: formData.preferredLanguage }),
      ...(formData.dateOfBirth && { dateOfBirth: formData.dateOfBirth }),
      // ...(isDevoteeSponsered && { devoteeSponsored: true }),
      ...(formData.joiningFromDate && { joiningFromDate: formData.joiningFromDate }),
      ...(formData.joiningToDate && { joiningToDate: formData.joiningToDate }),
      ...(formData.onlyRegisteredDevotees && { onlyRegisteredDevotees: formData.onlyRegisteredDevotees ? "true" : "false" }),

      pagination: true,
      pageNumber: 1,
      pageSize: 20,
      reportCustomOutputFields: {
        name: checkedItems.Name,
        address: checkedItems.Address,
        signInName: checkedItems['Sign-in Name'],
        homePhone: checkedItems['Home Phone'],
        workPhone: checkedItems['Work Phone'],
        email: checkedItems.Email,
        preferredLanguage: checkedItems['Preferred Language'],
        dateOfBirth: checkedItems['Date of Birth'],
        serialNumber: checkedItems['Serial Number'],
      }
    };
    setLoading(true)
    apiRequest({
      method: "POST",
      endpoint: "/report-dashboard/reports/devotee/DEVOTEE_REPORT/browser",
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        setLoading(false)
        let counter = 1;
        const getFormattedAddress = (address:any, city:any, state:any, country:any, zipcode:any) => {
          const parts = [address, city, state, country, zipcode].filter(Boolean);
          return parts.length > 0 ? parts.join(' ') : '-';
        };
        const getFormattedName = (firstname:any, middlename:any, lastname:any) => {
          const parts = [firstname, middlename, lastname].filter(Boolean);
          return parts.length > 0 ? parts.join(' ') : '-';
        };
        const response = res.data[0].data.map((item: any) => {
          return {
            "Serial Number": counter++,
            "Name": getFormattedName(item.firstname, item.middlename, item.lastname),
            "Address": getFormattedAddress(item.address, item.city, item.state, item.country, item.zipcode),
            "Sign-in Name": item.username || '-',
            "Home Phone": item.phoneresidence || '-',
            "Work Phone": item.phonework || '-',
            "Email": item.email || '-',
            "Preferred Language": item.preferredlanguage || '-',
            "Date of Birth": item.dateofbirth || '-',
          }
        })
        sendDataToParent(true, { reqBody, selectedColumns, response,reportName:"Devotee Report",
          totalElements:res.data[0].totalElements,
          pageSize:res.data[0].pagesize });
        // getReportData(res.data);
        getReportData(response);
      })
      .catch((err) => {
        setLoading(false)
      });
  };

  const handlSubmitZipcodereport = () => {
    const reqBody = {
      // zipcodeAndNumberOfDevotees: true,
       pagination: true,
      pageNumber: 1,
      pageSize: 20,
    };
    setLoading_zipcode(true)
    apiRequest({
      method: "POST",
      endpoint:
        "/report-dashboard/reports/devotee/NUMBER_OF_DEVOTEES_AND_ZIPCODE_REPORT/browser",
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        setLoading_zipcode(false)
        const response = res.data[0].data.map((item: any) => {
          return {
            "Number of Devotees":item.usercount,
            "Zipcode": item.zipcode,
            "City": item.city,
            "State": item.state,
            "Country": item.country,
          }
        })
        sendDataToParent(true, {reqBody, response, reportName:'Devotees and Zipcode',  
          totalElements:res.data[0].totalElements,
          pageSize:res.data[0].pagesize});
        // getReportData(res.data);
        getReportData(response);
      })
      .catch((err) => {
        setLoading_zipcode(false)
      });
  };

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: "/devotee-management/categories",
      params: {
        size: 500,
      },
      includeToken: true,
    })
      .then((res) => {
        setCategories(res.data.content);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [formData.category]);

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: "/address/public/states",
      params: {
        size: 500,
      },
      includeToken: true,
    })
      .then((res) => {
        setStates(res.data.content);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [formData.state]);

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: "/administration/public/languages",
      params: {
        size: 500,
      },
      includeToken: true,
    })
      .then((res) => {
        setLanguageItems(res.data.content);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [formData.preferredLanguage]);

  const DobDatePickerDevoteeReport = (): React.ReactElement => {
    return (
      <div className={styles.dateconatiner}>
        <StyledDateContainer className={styles.styledConatiner}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD"
                value={
                  formData.dateOfBirth
                    ? dayjs(formData.dateOfBirth, "MM-DD-YYYY")
                    : ""
                }
                onChange={(value) => {
                  handleFieldChange("dateOfBirth", value);
                }}
                disableFuture
                className={styles.dateFeildforfamily}
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </div>
    );
  };

  const JoiningDateFrom = (): React.ReactElement => {
    return (
      <div className={styles.dateconatiner}>
        <StyledDateContainer className={styles.styledConatiner}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  formData.joiningFromDate
                    ? dayjs(formData.joiningFromDate, "MM-DD-YYYY")
                    : ""
                }
                onChange={(value) => {
                  handleFieldChange("joiningFromDate", value);
                }}
                disableFuture
                className={styles.dateFeildforfamily}
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </div>
    );
  };

  const JoiningDateTo = (): React.ReactElement => {
    return (
      <div className={styles.dateconatiner}>
        <StyledDateContainer className={styles.styledConatiner}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  formData.joiningToDate
                    ? dayjs(formData.joiningToDate, "MM-DD-YYYY")
                    : ""
                }
                onChange={(value) => {
                  handleFieldChange("joiningToDate", value);
                }}
                disableFuture
                className={styles.dateFeildforfamily}
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </div>
    );
  };

  const handleClear = () => {
    setformData(formFieldsDevoteeReport);
  };

  const [openSearchDevotee, setOpenSearchDevotee] = useState(false);

  const handleOpenSearchDevoteeDialog = () => {
    setOpenSearchDevotee(true);
  }

  const handleClose = () => {
    setOpenSearchDevotee(false);
  }

  const hanldeSelectUser = (username: string) => {
    handleFieldChange(
      "signInName",
      username?.toUpperCase()
    );
    handleClose();
  }

  const CategoryDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%" }}>
        <CustomSelectField
          id="category"
          handleDropdownChange={handleFieldChange}
          errorMessage={""}
          dropDownList={categories}
          value={formData.category}
          fieldName="category"
          placeholder="Select"
          optionLabel="name"
          optionValue="id"
          overrideStyles={{ backgroundColor: "white" }}
        />
      </FormControl>
    );
  };

  const StatesDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%" }}>
        <CustomSelectField
          id="state"
          handleDropdownChange={handleFieldChange}
          errorMessage={""}
          dropDownList={states}
          value={formData.state}
          fieldName="state"
          placeholder="Select"
          optionLabel="stateName"
          optionValue="stateCode"
          overrideStyles={{ backgroundColor: "white" }}
        />
      </FormControl>
    );
  };

  const languagesDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%" }}>
        <CustomSelectField
          id="category"
          handleDropdownChange={handleFieldChange}
          errorMessage={""}
          dropDownList={languageItems}
          value={formData.preferredLanguage}
          fieldName="preferredLanguage"
          placeholder="Select"
          optionLabel="name"
          optionValue="name"
          overrideStyles={{ backgroundColor: "white !important" }}
        />
      </FormControl>
    );
  };

  const countriesDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%" }}>
        <CustomSelectField
          id="category"
          handleDropdownChange={handleFieldChange}
          errorMessage={""}
          dropDownList={CONSTANTS.countryList}
          value={formData.country}
          fieldName="country"
          placeholder="Select"
          optionLabel="key"
          optionValue="value"
          overrideStyles={{ backgroundColor: "white" }}
        />
      </FormControl>
    );
  };

  const TableRowsDisplayingCheckBoxes = () => {
    return (
      <>
        <Box style={{ width: "100%" }}>
          {CustomRequiredInputLabel("Fields", false)}
          <Box sx={{ display: "grid", gridTemplateColumns: "auto auto auto auto auto" }}>
            {checkBoxSequence.map((item) => (
              <Box key={item.ID}>
                <FormControlLabel
                  control={
                    <CustomCheckbox
                      className={styles.checkTitle}
                      id={`${item.ID}`}
                      size="medium"
                      checked={checkedItems[item.ID]}
                      onChange={() => handleCheckboxChange(item.ID)}
                    />
                  }
                  label={item.fieldName}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </>
    );
  };

  return (
    <Box className={styles.poojareportsLayout}>
      <CustomInputLabel style={{ whiteSpace: "normal", fontWeight: "bold" }}>
        You can generate list of devotees by using this report. There are
        various search criteria you could select to generate the report.
        <br />
        <br />
        Once you select the search criteria you can opt for the information to
        be displayed in the report by selecting the below checkbox fields. By
        default Name and Address of the devotee will be displayed in a tabular
        format. Information about devotees will be displayed by alphabetical
        order(Last Name) and in left-to-right format. Depending on your
        requirement you could select the number of columns and other fields.
      </CustomInputLabel>
      <Grid container spacing={2} sx={{ marginTop: "0px !important" }}>
        <Grid item xs={12} sm={3}>
          <CustomInputLabel>Last Name Starts With</CustomInputLabel>
          <CustomTextFeildforFamily
            style={{ minWidth: "100%", borderRadius: "8px" }}
            fullWidth
            value={formData.lastNameStartsWith}
            onChange={(e) => {
              handleFieldChange("lastNameStartsWith", e.target.value);
            }}
            className={styles.dateFeild}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <CustomInputLabel>Category</CustomInputLabel>
          {CategoryDropdown()}
        </Grid>
        <Grid item xs={12} sm={3}>
          <CustomInputLabel>Zip Code</CustomInputLabel>
          <CustomTextFeildforFamily
            style={{ minWidth: "100%", borderRadius: "8px" }}
            fullWidth
            value={formData.zipCode}
            onChange={(e) => {
              const inputValue = e.target.value.replace(/[^0-9.]/g, "");
              handleFieldChange("zipCode", inputValue);
            }}
            className={styles.dateFeild}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <CustomInputLabel>City</CustomInputLabel>
          <CustomTextFeildforFamily
            style={{ minWidth: "100%", borderRadius: "8px" }}
            fullWidth
            value={formData.city}
            onChange={(e) => {
              handleFieldChange("city", e.target.value);
            }}
            className={styles.dateFeild}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <CustomInputLabel>State</CustomInputLabel>
          {StatesDropdown()}
        </Grid>
        <Grid item xs={12} sm={3}>
          <CustomInputLabel>Country</CustomInputLabel>
          {countriesDropdown()}
        </Grid>
        <Grid item xs={12} sm={3}>
          <CustomInputLabel>Email</CustomInputLabel>
          <CustomTextFeildforFamily
            style={{ minWidth: "100%", borderRadius: "8px" }}
            fullWidth
            value={formData.email}
            onChange={(e) => {
              handleFieldChange("email", e.target.value);
            }}
            className={styles.dateFeild}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <CustomInputLabel>Sign-in Name</CustomInputLabel>
          <CustomTextFeildforFamily
            style={{ minWidth: "100%", borderRadius: "8px" }}
            fullWidth
            value={formData.signInName}
            onChange={(e) => {
              handleFieldChange("signInName", e.target.value);
            }}
            className={styles.dateFeild}
            sx={{
              background: "#fff !important",
              "& .MuiOutlinedInput-root": {
                pr: "7px",
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <PersonSearch
                    sx={{ ml: "10px", cursor: "pointer", color: "#F05802" }}
                    onClick={handleOpenSearchDevoteeDialog}
                  />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ marginTop: "0px" }}>
        <Grid item xs={12} sm={3}>
          <CustomInputLabel>Home Phone Number</CustomInputLabel>
          <CustomTextFeildforFamily
            style={{ minWidth: "100%", borderRadius: "8px" }}
            fullWidth
            value={formData.homePhoneNumber}
            onChange={(e) => {
              const inputValue = e.target.value.replace(/[^0-9.]/g, "");
              handleFieldChange("homePhoneNumber", inputValue);
            }}
            className={styles.dateFeild}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <CustomInputLabel>Work Phone Number</CustomInputLabel>
          <CustomTextFeildforFamily
            style={{ minWidth: "100%", borderRadius: "8px" }}
            fullWidth
            value={formData.workPhoneNumber}
            onChange={(e) => {
              const inputValue = e.target.value.replace(/[^0-9.]/g, "");
              handleFieldChange("workPhoneNumber", inputValue);
            }}
            className={styles.dateFeild}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <CustomInputLabel>Preferred Language</CustomInputLabel>
          {languagesDropdown()}
        </Grid>
        <Grid item xs={12} sm={3}>
          {CustomRequiredInputLabel("DOB", false)}
          {DobDatePickerDevoteeReport()}
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mt: 0 }}>
        <Grid item xs={12} sm={3}>
          {CustomRequiredInputLabel("Joining Date From", false)}
          {JoiningDateFrom()}
        </Grid>
        <Grid item xs={12} sm={3}>
          {CustomRequiredInputLabel("Joining Date To", false)}
          {JoiningDateTo()}
        </Grid>
        <Grid sx={{ display: "flex", alignItems: "center", marginTop:"35px" }}>
          <CustomCheckbox
            id="categorycheck"
            checked={formData.onlyRegisteredDevotees}
            onChange={(e) => handleFieldChange("onlyRegisteredDevotees", e.target.checked)}
          />
          <CustomInputLabel>Only Registered</CustomInputLabel>
        </Grid>
      </Grid>

      <Divider sx={{ color: "#000", width: "100%", margin: "16px 0" }} />
      {TableRowsDisplayingCheckBoxes()}

      <Box sx={{ display: "flex", gap: "16px", marginTop: "16px" }}>
        <CommonButton
          sx={{ width: "fit-content", height: "38px" }}
          onClick={handlSubmitDevoteereport}
          disabled={loading || selectedColumns.length === 0}
          id="submit"
        >
          {loading ? (
            <>
              <ClipLoader color="#fff" loading={loading} size={15} />
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                Submitting...
              </span>
            </>
          ) : (
            "Submit"
          )}
        </CommonButton>
        <CommonButton
          sx={{ width: "fit-content", height: "38px" }}
          onClick={handlSubmitZipcodereport}
          disabled={loading_zipcode}
          id="Zipcode"
        >
          {loading_zipcode ? (
            <>
              <ClipLoader color="#fff" loading={loading_zipcode} size={15} />
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                Loading...
              </span>
            </>
          ) : (
            "Zipcode and No of Devotees"
          )}
        </CommonButton>
        <CommonOutlinedButton onClick={handleClear}>Reset</CommonOutlinedButton>
        {openSearchDevotee && (
          <ReportsSearchDevotee
            open={openSearchDevotee}
            handleClose={handleClose}
            hanldeSelectUser={hanldeSelectUser}
          />
        )}
      </Box>
    </Box>
  );
};

export default DevoteeReport;